import type { FixtureFolder } from './types'
import { celestialDemoFolders } from './celestial-demo'

export const folders: readonly FixtureFolder[] = [
  {
    id: 'folder.docs.en',
    slug: 'docs-en',
    title: 'Docs',
    description: 'The English internal guide to Lorestra.',
    parentId: null,
    order: 10,
    visibility: 'public',
    locale: 'en',
  },
  {
    id: 'folder.docs.pt-br',
    slug: 'docs-pt-br',
    title: 'Docs',
    description: 'A documentação interna brasileira do Lorestra.',
    parentId: null,
    order: 20,
    visibility: 'public',
    locale: 'pt-BR',
  },
  {
    id: 'folder.engineering',
    slug: 'engineering',
    title: 'Engineering',
    description: 'Architecture, contracts, runtime decisions, and operations.',
    parentId: null,
    order: 30,
    visibility: 'public',
    locale: 'all',
  },
  {
    id: 'folder.product',
    slug: 'product',
    title: 'Product',
    description: 'Product intent, discovery, decisions, and launch practice.',
    parentId: null,
    order: 40,
    visibility: 'public',
    locale: 'all',
  },
  {
    id: 'folder.team',
    slug: 'team',
    title: 'Team',
    description: 'Ways of working for humans and multiple agents.',
    parentId: null,
    order: 50,
    visibility: 'public',
    locale: 'all',
  },
  ...celestialDemoFolders,
]
